import { slice } from '../slices/common';

const nameSpace = slice.name;

export const commentsSelector = (state) => state[nameSpace].comments;
export const downloadSelector = (state) => state[nameSpace].download;
export const transcriptDownloadSelector = (state) => state[nameSpace].transcriptDownload;
export const appearanceSelector = (state) => state[nameSpace].appearance;
export const autoplayNextSelector = (state) => state[nameSpace].autoplayNext;
export const autoplaySelector = (state) => state[nameSpace].autoplay;
export const autoplayMobileSelector = (state) => state[nameSpace].autoplayMobile;
export const basePathSelector = (state) => state[nameSpace].basePath;
export const channelsSelector = (state) => state[nameSpace].channels;
export const chaptersSelector = (state) => state[nameSpace].chapters;
export const cssSelector = (state) => state[nameSpace].css;
export const jsSelector = (state) => state[nameSpace].js;
export const dsRedirectSelector = (state) => state[nameSpace].dsRedirect;
export const dsTagsSelector = (state) => state[nameSpace].dsTags;
export const delayPreviewSelector = (state) => state[nameSpace].delayPreview;
export const descriptionSelector = (state) => state[nameSpace].description;
export const dockMobileSelector = (state) => state[nameSpace].dockMobile;
export const dblClickFlowSelector = (state) => state[nameSpace].dblClickFlow;
export const slidesSelector = (state) => state[nameSpace].slides;
export const tagsSelector = (state) => state[nameSpace].tags;
export const environmentSelector = (state) => state[nameSpace].environment;
export const excludedTagsSelector = (state) => state[nameSpace].excludedTags;
export const fixedTagsSelector = (state) => state[nameSpace].fixedTags;
export const genAISelector = (state) => state[nameSpace].genAI;
export const genAICountSelector = (state) => state[nameSpace].genAICount;
export const bgSelector = (state) => state[nameSpace].bg;
export const colorSelector = (state) => state[nameSpace].color;
export const fontSelector = (state) => state[nameSpace].font;
export const fontSizeSelector = (state) => state[nameSpace].fontSize;
export const offsetBottomSelector = (state) => state[nameSpace].offsetBottom;
export const offsetTopSelector = (state) => state[nameSpace].offsetTop;
export const idSelector = (state) => state[nameSpace].id;
export const inlinePlayerSelector = (state) => state[nameSpace].inlinePlayer;
export const inlineVerticalPlayerSelector = (state) => state[nameSpace].inlineVerticalPlayer;
export const deepSearchSelector = (state) => state[nameSpace].deepSearch;
export const highlightsSelector = (state) => state[nameSpace].highlights;
export const searchSelector = (state) => state[nameSpace].search;
export const videoPreviewSelector = (state) => state[nameSpace].videoPreview;
export const languagesSelector = (state) => state[nameSpace].languages;
export const popupSizeSelector = (state) => state[nameSpace].popupSize;
export const layoutSelector = (state) => state[nameSpace].layout;
export const tabOrderSelector = (state) => state[nameSpace].tabOrder;
export const playerSelector = (state) => state[nameSpace].player;
export const widgetOriginSelector = (state) => state[nameSpace].widgetOrigin;
export const widgetPathSelector = (state) => state[nameSpace].widgetPath;
export const publisherSelector = (state) => state[nameSpace].publisher;
export const sTitleColorSelector = (state) => state[nameSpace].sTitleColor;
export const sTitleSizeSelector = (state) => state[nameSpace].sTitleSize;
export const sVidInfoColorSelector = (state) => state[nameSpace].sVidInfoColor;
export const sVidInfoSizeSelector = (state) => state[nameSpace].sVidInfoSize;
export const sVidTitleColorSelector = (state) => state[nameSpace].sVidTitleColor;
export const sVidTitleSizeSelector = (state) => state[nameSpace].sVidTitleSize;
export const cDescColorSelector = (state) => state[nameSpace].cDescColor;
export const cDescSizeSelector = (state) => state[nameSpace].cDescSize;
export const cTitleColorSelector = (state) => state[nameSpace].cTitleColor;
export const cTitleSizeSelector = (state) => state[nameSpace].cTitleSize;
export const cInfoColorSelector = (state) => state[nameSpace].cInfoColor;
export const cVidTitleColorSelector = (state) => state[nameSpace].cVidTitleColor;
export const cVidTitleSizeSelector = (state) => state[nameSpace].cVidTitleSize;
export const searchPlaceholderSelector = (state) => state[nameSpace].searchPlaceholder;
export const searchLabelSelector = (state) => state[nameSpace].searchLabel;
export const emailShareSelector = (state) => state[nameSpace].emailShare;
export const socialShareSelector = (state) => state[nameSpace].socialShare;
export const backMobileSelector = (state) => state[nameSpace].backMobile;
export const soundSelector = (state) => state[nameSpace].sound;
export const soundMobileSelector = (state) => state[nameSpace].soundMobile;
export const statusSelector = (state) => state[nameSpace].status;
export const tagPagesSelector = (state) => state[nameSpace].tagPages;
export const tagCountSelector = (state) => state[nameSpace].tagCount;
export const tagMaxSelector = (state) => state[nameSpace].tagMax;
export const tagMinSelector = (state) => state[nameSpace].tagMin;
export const tagTypesSelector = (state) => state[nameSpace].tagTypes;
export const titleSelector = (state) => state[nameSpace].title;
export const shareServiceSelector = (state) => state[nameSpace].shareService;
export const verticalPlayerSelector = (state) => state[nameSpace].verticalPlayer;
export const engagementSelector = (state) => state[nameSpace].engagement;
export const configWasLoadedSelector = (state) => state[nameSpace].configWasLoaded;
export const isFavoritesUpdatingSelector = (state) => state[nameSpace].isFavoritesUpdating;
export const adsPlayStateSelector = (state) => state[nameSpace].adsPlayState;
export const formDisplayStateSelector = (state) => state[nameSpace].formDisplayState;
export const isFavoritesVideoWasLoadedSelector = (state) => state[nameSpace].isFavoritesVideoWasLoaded;
export const sortBySelector = (state) => state[nameSpace].sortBy;
export const sortOrderSelector = (state) => state[nameSpace].sortOrder;
export const additionalVideoSelector = (state) => state[nameSpace].additionalVideo;
export const favoritesVideoSelector = (state) => state[nameSpace].favoritesVideo;
